import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=f86a69a0&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"
import style0 from "./customer.vue?vue&type=style&index=0&id=f86a69a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86a69a0",
  null
  
)

export default component.exports